import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';

import './loader.scss';

export const Loader = () => {
  return (
    <div className="loader__wrapper">
      <LoadingOutlined className="loader" />
    </div>
  );
};
